import { isEmpty } from 'ramda'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import SuiteInfo from '@/features/Listing/suite-info'
import LandlordPadPayment from '@/features/Payments/landlord-pad-payment'
import usePayment from '@/pages/Rentals/Payments/use-payment'

const Wrapper = styled.div``

const TenantPayment = ({
  match: {
    params: { listingId, paymentId }
  }
}) => {
  const { t } = useTranslation()
  const paymentData = usePayment({ paymentId, listingId })

  if (!paymentData || isEmpty(paymentData)) return null

  return (
    <Wrapper>
      <Helmet>
        <title>{t('b.payments.view.payments.title', 'Payments')}</title>
      </Helmet>
      <SuiteInfo listingId={listingId} />
      <LandlordPadPayment paymentId={paymentId} paymentData={paymentData} listingId={listingId} />
    </Wrapper>
  )
}

export default TenantPayment
